import { HAS_VIEWED_PRODUCTS, INCREMENT_VIEWED_PRODUCTS } from './constants';

export default function (state = {}, action) {
  switch (action.type) {
    case INCREMENT_VIEWED_PRODUCTS: {
      const { nextShowIndex } = action;
      return {
        ...state,
        recentNewShowIndex: nextShowIndex,
      };
    }
    case HAS_VIEWED_PRODUCTS: {
      const { payload } = action;
      return {
        ...state,
        payload,
      };
    }
    default:
      return state;
  }
}
